import type { ReactNode } from 'react';

export const symbol_diagnosis: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M350-210h260q12.75 0 21.38-8.68 8.62-8.67 8.62-21.5 0-12.82-8.62-21.32-8.63-8.5-21.38-8.5H350q-12.75 0-21.37 8.68-8.63 8.67-8.63 21.5 0 12.82 8.63 21.32 8.62 8.5 21.37 8.5Zm0-120h260q12.75 0 21.38-8.68 8.62-8.67 8.62-21.5 0-12.82-8.62-21.32-8.63-8.5-21.38-8.5H350q-12.75 0-21.37 8.68-8.63 8.67-8.63 21.5 0 12.82 8.63 21.32 8.62 8.5 21.37 8.5Zm130-382q-15-19-31-28.5t-41-9.5q-31.91 0-54.95 23.05Q330-703.91 330-672q0 52 47.5 95.5T460-502q8.19 8 20.09 8 11.91 0 19.91-8 35-31 82.5-75t47.5-95q0-31.91-23.05-54.95Q583.91-750 552-750q-25 0-41 9.5T480-712ZM740-80H220q-24 0-42-18t-18-42v-680q0-24 18-42t42-18h520q24 0 42 18t18 42v680q0 24-18 42t-42 18Zm-520-60h520v-680H220v680Zm0 0v-680 680Z"
		/>
	</svg>
);
